import React, { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import Root from "./root";
import SelectProjectType from "../pages/Projects/SelectProjectType";
import CreateDomain from "../pages/Domains/CreateDomain";
import EditDomain from "../pages/Domains/EditDomain";
import CreateProject from "../pages/Projects/CreateProject";
import EditProject from "../pages/Projects/EditProject";
import ViewProject from "../pages/Projects/ViewProject";
import CreateTutorial from "../pages/Tutorials/CreateTutorial";
import EditTutorial from "../pages/Tutorials/EditTutorial";
import CreateAgency from "../pages/Agencies/CreateAgency";
import EditAgency from "../pages/Agencies/EditAgency";
import ResetPasswordForm from "../pages/ResetPassword/ResetPasswordForm";
import LoaderSpinner from "../components/LoaderSpinner";
import Notification from "../pages/Notification/Notification";

const Login = lazy(() => import("../pages/Login"));
const SignUp = lazy(() => import("../pages/SignUp"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Projects = lazy(() => import("../pages/Projects"));
const Domains = lazy(() => import("../pages/Domains"));
const MyAgency = lazy(() => import("../pages/MyAgency"));
const Tutorials = lazy(() => import("../pages/Tutorials"));
const Resources = lazy(() => import("../pages/Resources"));
const Settings = lazy(() => import("../pages/Settings"));
const Integrations = lazy(() => import("../pages/Integrations"));
const PaymentMethods = lazy(() => import("../pages/PaymentMethods"));
const Reporting = lazy(() => import("../pages/Reporting"));
const ResetPassword = lazy(() => import("../pages/ResetPassword"));
const ScanReporting = lazy(() => import("../pages/ScanReporting"));
const StripeProducts = lazy(() => import("../pages/StripeProducts"));
const StripeSubscriptions = lazy(() => import("../pages/StripeSubscriptions"));
const Agencies = lazy(() => import("../pages/Agencies"));
const AllUsers = lazy(() => import("../pages/AllUsers"));
const ErrorPage = lazy(() => import("../router/ErrorPage.js"));

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Login />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/login",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Login />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/registration",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <SignUp />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/password/reset",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <ResetPassword />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/password-reset",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <ResetPasswordForm />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },

  {
    path: "/dashboard",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Dashboard />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/projects",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Projects />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/projects/select-project-type",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<SelectProjectType />} />
      </Suspense>
    ),
  },
  {
    path: "/projects/create-project",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<CreateProject />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/projects/:id",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<ViewProject />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/projects/:id/edit",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<EditProject />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/domains",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Domains />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/add-domain",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<CreateDomain />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/domains/:id/edit",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<EditDomain />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/domains/add-domain",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<CreateDomain />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/reporting",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Reporting />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/reporting/scan-reporting",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<ScanReporting />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/resources",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Resources />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/scan-reporting",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<ScanReporting />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/integrations",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Integrations />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/tutorials",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Tutorials />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/tutorials/create",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<CreateTutorial />} />
      </Suspense>
    ),
  },
  {
    path: "/tutorials/:id/edit",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<EditTutorial />} />
      </Suspense>
    ),
  },
  {
    path: "/settings",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Settings />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/my-agency",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<MyAgency />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/agencies",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Agencies />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/agencies/create",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<CreateAgency />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/agencies/:id/edit",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<EditAgency />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/stripe/products",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<StripeProducts />} />
      </Suspense>
    ),
  },
  {
    path: "/stripe/all-subscriptions",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<StripeSubscriptions />} />
      </Suspense>
    ),
  },
  {
    path: "/payment",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<PaymentMethods />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/stripe/all-users",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<AllUsers />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/notifications/:id",
    element: (
      <Suspense fallback={<LoaderSpinner />}>
        {" "}
        <Root component={<Notification />} />,
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },
]);

export default router;
